import { render } from "./ImagePicker.vue?vue&type=template&id=45d447d9&scoped=true&ts=true"
import script from "./ImagePicker.vue?vue&type=script&lang=ts"
export * from "./ImagePicker.vue?vue&type=script&lang=ts"

import "./ImagePicker.vue?vue&type=style&index=0&id=45d447d9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d447d9"]])

export default __exports__